import { render } from "./PayrollLeisure.vue?vue&type=template&id=2d1a7823&ts=true"
import script from "./PayrollLeisure.vue?vue&type=script&lang=ts"
export * from "./PayrollLeisure.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__